import { api } from '../../DefaultService';
import {
  IEscolaWebCreateProps,
  IEscolaWebProps,
  IEscolaWebUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/escolaweb';

export const createEscolaWebIntegrationAsync = async (
  data: IEscolaWebCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllEscolaWebIntegrationsAsync = async (): Promise<
  IEscolaWebProps[]
> => {
  return await api
    .get<IEscolaWebProps[]>(`${ENDPOINT}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getEscolaWebIntegrationByIdAsync = async (
  id: number,
): Promise<IEscolaWebProps> => {
  return await api
    .get<IEscolaWebProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateEscolaWebIntegrationAsync = async ({
  id,
  data,
}: IEscolaWebUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteEscolaWebIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
